import { render } from "./Item.vue?vue&type=template&id=1970de6b&scoped=true&ts=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=1970de6b&lang=stylus&scoped=true"
import "./Item.vue?vue&type=style&index=1&id=1970de6b&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1970de6b"]])

export default __exports__